import dayjs from "dayjs"
import { useCallback } from "react"
import { useSearchParams } from "react-router-dom"

const defaultStartOfThisWeek = dayjs().startOf("week").format("YYYY-MM-DD")

export const useStartOfWeekQuery = () => {
    const [searchParams, setSearchParams] = useSearchParams(
        new URLSearchParams({
            startOfWeek: defaultStartOfThisWeek
        })
    )

    const onChange = useCallback(
        (newStartOfWeek: string) => {
            setSearchParams({ startOfWeek: newStartOfWeek })
        },
        [setSearchParams]
    )

    return {
        startOfWeek: searchParams.get("startOfWeek") ?? defaultStartOfThisWeek,
        onChange
    }
}
